import type { DocumentInfo, OrderState } from 'api';
import { createContext, type ReactNode } from 'react';

import type { UpdateFormValues } from '../pages/PurchaseOrderUpdate/PurchaseOrderUpdate';
import type { OrderFormVariant } from './OrderFormVariant';

type PurchaseOrderFormContextType = {
  variant: OrderFormVariant;
  defaultValues: UpdateFormValues | undefined;
  documents: DocumentInfo[];
  purchaseOrderState: OrderState | undefined;
};

export const PurchaseOrderFormContext = createContext<PurchaseOrderFormContextType>({
  defaultValues: undefined,
  documents: [],
  purchaseOrderState: undefined,
  variant: undefined,
});

export const FormContextProvider = ({
  children,
  defaultValues,
  documents,
  variant,
  purchaseOrderState,
}: {
  children: ReactNode;
  defaultValues: UpdateFormValues | undefined;
  variant: OrderFormVariant;
  documents: DocumentInfo[];
  purchaseOrderState: OrderState | undefined;
}) => {
  return (
    <PurchaseOrderFormContext.Provider value={{ defaultValues, documents, purchaseOrderState, variant }}>
      {children}
    </PurchaseOrderFormContext.Provider>
  );
};
